import React, { useState } from "react";
import styles from "./ImageWithLoader.module.scss";

const ImageWithLoader = (props: {
  src: string;
  className?: string;
  alt?: string;
}) => {
  const [loading, setLoading] = useState(true);
  const handleLoad = () => setLoading(false);
  return (
    <>
      {loading && (
        <div className={styles.ShimmerContainer}>
          <div className={styles.Shimmer}></div>
        </div>
      )}
      <img
        src={props.src}
        alt={props.alt ?? "image"}
        onLoad={handleLoad}
        // TODO: onError={handleError} could be handled
        style={{ display: loading ? "none" : "block" }}
        className={props.className}
      />
    </>
  );
};

export default ImageWithLoader;
